<template>
  <div class="cavas-box">
    <div
      ref="barmore"
      id="barmore"
      style="z-index: 100; widht: 100%; height: 100%"
      @click="clickUp"
    ></div>
    <div
      v-show="selected"
      class="bar-maske"
      :style="{ left: left2, width: width }"
    ></div>
    <div v-show="selected" class="dot" :style="{ left: left }"></div>
  </div>
</template>
<script>
var echarts = require("echarts");
import GetBase64 from "@/assets/js/getBase64";
export default {
  data() {
    return {
      left: "0px",
      left2: "0px",
      width: "0px",
      myChart: null,
      list: [],
      selected: false,
      mediaName: "",
    };
  },
  methods: {
    creatbar() {
      let list = [...this.list];
      let arr = [];
      let arr2 = [];
      let serverData = [];
      let imgarry = [];
      list.forEach((item, index) => {
        if (index < 10) {
          arr.push(item.media_name);
          arr2.push(parseFloat(item.percent));
          if (item.img) {
            // GetBase64(item.img, (url) => {
            //   // imgarry.push("data:image/png;base64," + url);
            //   console.log(url)
            // });
            imgarry.push(item.img);
          } else {
            imgarry.push(null);
          }
        }
      });

      let colora = [
        "#1BA9EA",
        "#4EC7FF",
        "#74D3FF",
        "#AEE5FF",
        "#CAEEFF",
        "#788FD6",
        "#92A7E8",
        "#BACAFA",
        "#DEE6FF",
        "#EDEDED",
      ];
      let rich = {};
      let richkey = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"];
      imgarry.forEach((item, index) => {
        rich[richkey[index]] = {
          backgroundColor: {
            image: item,
          },
          widht: 45,
          height: 23,
        };
      });
      arr2.forEach((item, index) => {
        let dataobj = {
          value: item,
          img: imgarry[index],
          itemStyle: {
            color: colora[index],
            emphasis: { color: colora[index] },
          },
        };
        serverData.push(dataobj);
      });

      if (!this.$refs.barmore) {
        return;
      }
      this.myChart = echarts.init(document.getElementById("barmore"));
      this.myChart.off("click");
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            // triggerOn: "click",
            axisPointer: {
              type: "shadow",
              shadowStyle: {
                color: "transparent",
              },
            },
            show: true,
            textStyle: {
              align: "left",
            },
            formatter(params) {
              return params[0].name + ":" + params[0].data.value + "%";
              // +
              //   "<br>" +
              //   "声量数：" +
              //   params[0].data.nums
            },
          },

          xAxis: {
            type: "category",

            axisTick: {
              // 坐标轴 刻度
              show: false, // 是否显示
            },
            axisLine: {
              // 坐标轴 轴线
              show: true, // 是否显示
              lineStyle: {
                color: "#e4e4e4",
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {
              color: "#000",
              interval: 0,
            },
            //   axisPointer: {
            //     type: "shadow",
            //     handle: {
            //       show: true,
            //       size: 0,
            //     },
            //   },
            data: arr,
          },
          grid: {
            top: "56px",

            left: "40px",

            right: "0px",

            bottom: "50px",

            backgroundColor: "#fff",
          },
          // graphic: [
          //   {
          //     type: "image",
          //     id: "logo",
          //     top: "34%",
          //     left: "35%",
          //     z: 300,
          //     bounding: "raw",
          //     origin: [25, 25],
          //     style: {
          //       image: this.maskImage,
          //       width: 319,
          //       height: 103,
          //       opacity: 1,
          //     },
          //   },
          // ],

          yAxis: {
            type: "value",

            axisLabel: {
              formatter: "{value}%",
              color: "#000",
            },
            axisTick: {
              // 坐标轴 刻度
              show: false, // 是否显示
              lineStyle: {
                // 默认取轴线的样式
                color: "#e4e4e4",
                width: 1,
                type: "solid",
              },
            },
            axisLine: {
              // 坐标轴 轴线
              show: true, // 是否显示
              lineStyle: {
                color: "#e4e4e4",
                width: 1,
                type: "solid",
              },
            },

            splitLine: {
              show: false, //去掉网格线
            },
          },

          series: [
            {
              type: "bar",
              data: serverData,
              barWidth: 45,

              label: {
                show: true,
                position: "top",

                // formatter: ["{c}%", "{b|}"].join("\n"),
                formatter: function (params) {
                  if (params.dataIndex == 0) {
                    return [params.data.value + "%", "{a|}"].join("\n");
                  } else if (params.dataIndex == 1) {
                    return [params.data.value + "%", "{b|}"].join("\n");
                  } else if (params.dataIndex == 2) {
                    return [params.data.value + "%", "{c|}"].join("\n");
                  } else if (params.dataIndex == 3) {
                    return [params.data.value + "%", "{d|}"].join("\n");
                  } else if (params.dataIndex == 4) {
                    return [params.data.value + "%", "{e|}"].join("\n");
                  } else if (params.dataIndex == 5) {
                    return [params.data.value + "%", "{f|}"].join("\n");
                  } else if (params.dataIndex == 6) {
                    return [params.data.value + "%", "{g|}"].join("\n");
                  } else if (params.dataIndex == 7) {
                    return [params.data.value + "%", "{h|}"].join("\n");
                  } else if (params.dataIndex == 8) {
                    return [params.data.value + "%", "{i|}"].join("\n");
                  } else if (params.dataIndex == 9) {
                    return [params.data.value + "%", "{j|}"].join("\n");
                  }
                },
                textStyle: {
                  color: "#141A88",
                  fontSize: 14,
                  fontWeight: 700,
                },
                fontFamily: "AgencyFB",
                align: "center",
                rich: rich,
              },
            },
          ],
        },
        true
      );

      let that = this;

      this.myChart.on("click", function (params) {
        if (that.mediaName == params.name&&that.selected==true) {
          that.selected = false;
            that.$emit("changemeida",'');
        } else {
          that.left =
            params.event.target.shape.x +
            params.event.target.shape.width / 2 +
            10 +
            "px";
          that.left2 = params.event.target.shape.x - 9.4 + "px";
          that.width = params.event.target.shape.width + 16 + "px";
          that.$emit("changemeida", params.name);
          that.selected = true;
          that.mediaName=params.name;
        }
      });

      this.clickUp();
    },
    clickUp() {},
    open(list) {
      this.list = list;
      let len = this.list.length;
      this.left = (702 - 40) / len / 2 + 40 + 10 + "px";
      this.left2 = (702 - 40) / len / 2 + 40 - 9.4 - 22.5 + "px";
      this.width = 61 + "px";

      this.creatbar();
    },
  },
  mounted() {},
};
</script>
<style scoped>
.cavas-box {
  position: relative;
  width: 100%;
  height: 390px;
}
.dot {
  position: absolute;
  width: 16px;
  height: 16px;
  background: url("../../../assets/img/new/true-bar.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 50%;
  top: 15px;
  z-index: 100;
}
.bar-maske {
  position: absolute;
  height: 330px;
  top: 10px;
  background-color: #f2f5ff;
  border: 1px solid #d5d6ec;
  border-bottom: 0px;
}
</style>